import { classes } from '../../../utils/class-utils';

export const balloonContainerStyles = classes([
  'inline-flex',
  'items-center',
  'h-fit',
  'bg-[#F5F5F5]',
  'rounded-full',
  'border',
  'border-[#EBEBEB]',
  'my-1',
  'py-1',
  'pl-2',
]);

export const balloonBtnStyles = 'p-1';
